import React from 'react';
import {
  Box,
  Divider,
  List,
  ListItem,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LANGUAGE } from '@src/constants';
import { useTranslation } from 'react-i18next';
import { Check } from '@mui/icons-material';
import sanitizeHtml from 'sanitize-html';

const PackageFeature = ({ isMobile, pkg }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { featuresDescription = [], featuresTitle } = pkg || {};

  const getLocalizedContent = (content) =>
    language === LANGUAGE.VN ? content?.[language] : content?.[LANGUAGE.EN];

  const renderTitle = () => {
    if (!featuresTitle) return null;
    const localizedTitle = getLocalizedContent(featuresTitle);
    return (
      <Typography
        className="title-text"
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(localizedTitle) }}
      />
    );
  };

  const renderFeatureItem = (item, index) => {
    const localizedText =
      language === LANGUAGE.VN ? item[language] : item[LANGUAGE.EN];
    const advanced = item?.advanced;
    const comingSoon = item?.comingSoon;
    const tooltipText = item?.tooltip ? item.tooltip[language] || '' : '';

    return (
      <Box display="flex" justifyContent="space-between" key={item.vi || index}>
        <ListItem className="clarify">
          <Box style={{ width: '100%' }} className="flexItem">
            <div className="flexItem">
              <div className="icon-contents">
                <Check
                  fontSize="small"
                  className={
                    advanced
                      ? 'check-icon coming-soon-text-advanced'
                      : 'check-icon'
                  }
                />
              </div>
              <span className="item-package">
                <div
                  className={
                    advanced
                      ? 'coming-soon-text-advanced content'
                      : 'coming-soon-text content'
                  }
                >
                  {localizedText}
                  {comingSoon && (
                    <span className="coming-soon-title">
                      ({t('comingSoon')})
                    </span>
                  )}
                </div>
              </span>
            </div>
            <div className="tooltip">
              {!isMobile && item?.tooltip && (
                <Tooltip
                  arrow
                  title={tooltipText}
                  placement="left"
                  className="tootlip"
                >
                  <InfoOutlinedIcon />
                </Tooltip>
              )}
            </div>
          </Box>
        </ListItem>
      </Box>
    );
  };

  const renderFeatureList = () => {
    if (!featuresDescription.length) return null;
    return (
      <List>
        {featuresDescription.map((item, index) =>
          renderFeatureItem(item, index),
        )}
      </List>
    );
  };

  return (
    <>
      {featuresDescription.length > 0 && (
        <Divider className="divider-feature" />
      )}
      {renderTitle()}
      {renderFeatureList()}
    </>
  );
};

export default PackageFeature;
